import { useNavigate } from "react-router-dom";

const Image = (props) => {
  const navigate = useNavigate();

  const { onClick, path, src, ...restProps } = props;
  
  // Ensure the src path starts with the correct public URL
  const imageSrc = src && (src.startsWith('http') || src.startsWith('data:') || src.startsWith('blob:')) 
    ? src 
    : `${process.env.PUBLIC_URL}${src}`;

  return onClick ? (
    <img
      {...restProps}
      src={imageSrc}
      onClick={() => {
        path && navigate(path);
      }}
    />
  ) : (
    <img {...restProps} src={imageSrc} />
  );
};

export default Image;
